import type { ScreenContext } from './types.ts';
import { renderInsightCard } from '@/components/insight-card.ts';
import { createContinueButton } from '@/components/continue-button.ts';
import { getInsightText } from '@/calculations/insights.ts';

export function renderInsight(container: HTMLElement, ctx: ScreenContext) {
  const { state, dispatch } = ctx;
  const text = getInsightText(state, state.insightIndex);

  container.innerHTML = `
    <div class="card space-y-6">
      <div>
        <p class="text-sm uppercase tracking-wide text-gray-500">Insight ${state.insightIndex}</p>
        <h2 class="text-2xl font-semibold text-gray-900">What we notice</h2>
      </div>
      <div id="insight-slot"></div>
      <div id="action-slot"></div>
    </div>
  `;

  container.querySelector('#insight-slot')?.appendChild(renderInsightCard(text));
  const btn = createContinueButton('Continue');
  container.querySelector('#action-slot')?.appendChild(btn);

  btn.addEventListener('click', () => dispatch({ type: 'NEXT_PHASE' }));
}
